import { fromJS } from 'immutable';
import _ from 'lodash';

import * as arbitrationActions from '../actions/arbitration';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';

const initialStats = {
  arbitration: {
    data: {},
    state: null,
  },
  activeArbitration: null,
  arbitrations: {},
  searchArbitrations: {},
  newArbitration: {},
  arbitrationHeaders: {
    data: {},
    state: null,
  },
  arbitrationStatus: {
    data: {},
    state: null,
  },
  dropdowns: { data: {}, state: null },
  arbitrationUpdate: { state: null },
  arbitrationPresentation: { data: {}, state: null },
  presentationDocuments: { data: [], state: null },
  casePrep: { data: {}, state: null },
  events: { data: [], state: null },
  hearing: { data: {}, state: null },
  disposition: { data: {}, state: null },
  availableAgents: { data: {}, state: null },
  availableOwners: { data: {}, state: null },
  proposedRollCorrections: { data: [], state: null },
  incomeActual: { data: {}, state: null },
  incomeModel: { data: {}, state: null },
  notes: { data: [], state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case arbitrationActions.FETCH_ARBITRATION_NOTES[START]:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case arbitrationActions.FETCH_ARBITRATION_NOTES[SUCCESS]:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case arbitrationActions.FETCH_ARBITRATION_NOTES[ERROR]:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);
    case arbitrationActions.ADD_ARBITRATION_NOTE[SUCCESS]:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case arbitrationActions.DELETE_ARBITRATION_NOTE[SUCCESS]:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case arbitrationActions.UPDATE_ARBITRATION_NOTE[SUCCESS]:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));
    case arbitrationActions.INSERT_ARBITRATION[START]:
      return state.setIn(['arbitration', 'state'], fetchingState.SAVING);
    case arbitrationActions.INSERT_ARBITRATION[SUCCESS]:
      let newState = state.setIn(
        ['arbitration', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['arbitration', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitrationActions.INSERT_ARBITRATION[ERROR]:
      return state.setIn(['arbitration', 'state'], fetchingState.ERROR);
    case arbitrationActions.FETCH_ARBITRATION[START]:
      return state.setIn(['arbitration', 'state'], fetchingState.FETCHING);
    case arbitrationActions.FETCH_ARBITRATION[SUCCESS]:
    case arbitrationActions.FINALIZE_ARBITRATION[SUCCESS]:
    case arbitrationActions.REOPEN_ARBITRATION[SUCCESS]:
      newState = state.setIn(['arbitration', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['arbitration', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitrationActions.ARBITRATION_RESET_DATA:
      return state.setIn(['arbitration', 'data'], fromJS({}));
    case arbitrationActions.FETCH_ARBITRATION[ERROR]:
      return state.setIn(['arbitration', 'state'], fetchingState.ERROR);
    case arbitrationActions.ARBITRATION_VALIDATE_SUCCESS:
      return state.setIn(
        ['arbitration', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitrationActions.FETCH_ARBITRATION_HEADERS[START]:
      return state.setIn(
        ['arbitrationHeaders', 'state'],
        fetchingState.FETCHING,
      );
    case arbitrationActions.FETCH_ARBITRATION_HEADERS[SUCCESS]:
      newState = state.setIn(
        ['arbitrationHeaders', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['arbitrationHeaders', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitrationActions.FETCH_ARBITRATION_HEADERS[ERROR]:
      return state.setIn(['arbitrationHeaders', 'state'], fetchingState.ERROR);
    case arbitrationActions.FETCH_ARBITRATION_STATUS[START]:
      return state.setIn(
        ['arbitrationStatus', 'state'],
        fetchingState.FETCHING,
      );
    case arbitrationActions.FETCH_ARBITRATION_STATUS[SUCCESS]:
      newState = state.setIn(
        ['arbitrationStatus', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['arbitrationStatus', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitrationActions.FETCH_ARBITRATION_STATUS[ERROR]:
      return state.setIn(['arbitrationStatus', 'state'], fetchingState.ERROR);
    case arbitrationActions.SET_ACTIVE_ARBITRATION: {
      return state.setIn(['activeArbitration'], action.payload);
    }
    case arbitrationActions.RESET_ACTIVE_ARBITRATION: {
      return state.setIn(['activeArbitration'], null);
    }
    case arbitrationActions.FETCH_DROPDOWNS[START]:
      return state.setIn(['dropdowns', 'state'], fetchingState.FETCHING);
    case arbitrationActions.FETCH_DROPDOWNS[SUCCESS]:
      newState = state.setIn(['dropdowns', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['dropdowns', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );
    case arbitrationActions.FETCH_DROPDOWNS[ERROR]:
      return state.setIn(['dropdowns', 'state'], fetchingState.ERROR);
    case arbitrationActions.ARBITRATION_GENERAL_UPDATE[START]: {
      return state.setIn(
        ['arbitrationUpdate', 'state'],
        fetchingState.FETCHING,
      );
    }
    case arbitrationActions.ARBITRATION_GENERAL_UPDATE[SUCCESS]: {
      newState = state.setIn(
        ['arbitration', 'data'],
        fromJS(action.data.results[0]),
      );
      return newState.setIn(
        ['arbitrationUpdate', 'state'],
        fetchingState.LOADED,
      );
    }
    case arbitrationActions.ARBITRATION_GENERAL_UPDATE[ERROR]: {
      return state.setIn(['arbitrationUpdate', 'state'], fetchingState.ERROR);
    }
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION[START]: {
      return state.setIn(
        ['arbitrationPresentation', 'state'],
        fetchingState.FETCHING,
      );
    }
    case arbitrationActions.PUBLISH_ARBITRATION_PRESENTATION[SUCCESS]:
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION[SUCCESS]: {
      return state
        .setIn(['arbitrationPresentation', 'state'], fetchingState.LOADED)
        .setIn(
          ['arbitrationPresentation', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION[ERROR]: {
      return state.setIn(
        ['arbitrationPresentation', 'state'],
        fetchingState.ERROR,
      );
    }
    case arbitrationActions.DELETE_ARBITRATION_PRESENTATION_DOCUMENTS[
      SUCCESS
    ]: {
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(['presentationDocuments', 'data'], fromJS([]));
    }
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[START]: {
      return state.setIn(
        ['presentationDocuments', 'state'],
        fetchingState.FETCHING,
      );
    }
    case arbitrationActions.UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER[
      SUCCESS
    ]:
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[SUCCESS]: {
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['presentationDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case arbitrationActions.FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[ERROR]: {
      return state.setIn(
        ['presentationDocuments', 'state'],
        fetchingState.ERROR,
      );
    }

    case arbitrationActions.DELETE_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS]:
      return state.setIn(
        ['presentationDocuments', 'data'],
        fromJS([
          ...state
            .getIn(['presentationDocuments', 'data'])
            .toJS()
            .filter(
              d => d.arbitrationPresentationDocumentID !== action.documentID,
            ),
        ]),
      );

    case arbitrationActions.INSERT_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS]:
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['presentationDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );

    case arbitrationActions.GENERATE_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS]:
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['presentationDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );

    case arbitrationActions.FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[START]: {
      return state.setIn(['casePrep', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[
      SUCCESS
    ]: {
      return state
        .setIn(['casePrep', 'state'], fetchingState.LOADED)
        .setIn(
          ['casePrep', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case arbitrationActions.FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[ERROR]: {
      return state.setIn(['casePrep', 'state'], fetchingState.ERROR);
    }

    case arbitrationActions.UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[
      START
    ]: {
      return state.setIn(['casePrep', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[
      SUCCESS
    ]: {
      return state
        .setIn(['casePrep', 'state'], fetchingState.LOADED)
        .setIn(
          ['casePrep', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        )
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case arbitrationActions.UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[
      ERROR
    ]: {
      return state.setIn(['casePrep', 'state'], fetchingState.ERROR);
    }

    // EVENTS
    case arbitrationActions.FETCH_ARBITRATION_EVENTS[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_ARBITRATION_EVENTS[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case arbitrationActions.FETCH_ARBITRATION_EVENTS[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case arbitrationActions.ARBITRATION_EVENT_DELETE[SUCCESS]: {
      return state.setIn(
        ['events', 'data'],
        fromJS(
          state
            .getIn(['events', 'data'])
            .toJS()
            .filter(e => e.appealID !== action.appealID),
        ),
      );
    }

    // Hearing
    case arbitrationActions.FETCH_ARBITRATION_HEARING[START]: {
      return state.setIn(['hearing', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_ARBITRATION_HEARING[SUCCESS]: {
      return state
        .setIn(['hearing', 'state'], fetchingState.LOADED)
        .setIn(
          ['hearing', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case arbitrationActions.FETCH_ARBITRATION_HEARING[ERROR]: {
      return state.setIn(['hearing', 'state'], fetchingState.ERROR);
    }
    // Available Agents
    case arbitrationActions.FETCH_AVAILABLE_AGENTS[START]: {
      return state.setIn(['availableAgents', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_AVAILABLE_AGENTS[SUCCESS]: {
      return state
        .setIn(['availableAgents', 'state'], fetchingState.LOADED)
        .setIn(
          ['availableAgents', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case arbitrationActions.FETCH_AVAILABLE_AGENTS[ERROR]: {
      return state.setIn(['availableAgents', 'state'], fetchingState.ERROR);
    }
    // Available Owners
    case arbitrationActions.FETCH_AVAILABLE_OWNERS[START]: {
      return state.setIn(['availableOwners', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_AVAILABLE_OWNERS[SUCCESS]: {
      return state
        .setIn(['availableOwners', 'state'], fetchingState.LOADED)
        .setIn(
          ['availableOwners', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case arbitrationActions.FETCH_AVAILABLE_OWNERS[ERROR]: {
      return state.setIn(['availableOwners', 'state'], fetchingState.ERROR);
    }
    // Proposed Roll Corrections
    case arbitrationActions.FETCH_PROPOSED_ROLL_CORRECTIONS[START]: {
      return state.setIn(
        ['proposedRollCorrections', 'state'],
        fetchingState.FETCHING,
      );
    }
    case arbitrationActions.FETCH_PROPOSED_ROLL_CORRECTIONS[SUCCESS]: {
      return state
        .setIn(['proposedRollCorrections', 'state'], fetchingState.LOADED)
        .setIn(
          ['proposedRollCorrections', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case arbitrationActions.FETCH_PROPOSED_ROLL_CORRECTIONS[ERROR]: {
      return state.setIn(
        ['proposedRollCorrections', 'state'],
        fetchingState.ERROR,
      );
    }
    // Disposition
    case arbitrationActions.FETCH_DISPOSITION[START]: {
      return state.setIn(['disposition', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_DISPOSITION[SUCCESS]: {
      return state
        .setIn(['disposition', 'state'], fetchingState.LOADED)
        .setIn(
          ['disposition', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case arbitrationActions.FETCH_DISPOSITION[ERROR]: {
      return state.setIn(['disposition', 'state'], fetchingState.ERROR);
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_ACTUALS[ERROR]: {
      return state.setIn(['incomeActual', 'state'], fetchingState.ERROR);
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_ACTUALS[START]: {
      return state.setIn(['incomeActual', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_ACTUALS[SUCCESS]: {
      return state
        .setIn(['incomeActual', 'state'], fetchingState.LOADED)
        .setIn(
          ['incomeActual', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_MODELS[ERROR]: {
      return state.setIn(['incomeModel', 'state'], fetchingState.ERROR);
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_MODELS[START]: {
      return state.setIn(['incomeModel', 'state'], fetchingState.FETCHING);
    }
    case arbitrationActions.FETCH_ARBITRATION_INCOME_MODELS[SUCCESS]: {
      return state
        .setIn(['incomeModel', 'state'], fetchingState.LOADED)
        .setIn(
          ['incomeModel', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    default:
      return state;
  }
};
